import React, { useState, useEffect, useCallback } from "react";
import Sidebar from "../../sidebar/sidebar";
import TopBar from "../../topbar/TopBar";
import { useNavigate } from "react-router-dom";
import searchIcon from "../../../assets/svg/search_gray.svg";
import sortIcon from "../../../assets/svg/df.svg";
import filterIcon from "../../../assets/svg/filt.svg";
import addIcon from "../../../assets/svg/plus.svg";
import dropDownIcon from "../../../assets/svg/dropdown.svg";
import defaultProfile from "../../../assets/png/user-icon.png";
import CustomPagination from "../../common/CustomPagination";
import { getNfcList } from "./nfc-api";
import { useGlobal } from "../../../GlobalContext";
import { Row, Col } from "react-bootstrap";

const NfcList = () => {
  const navigate = useNavigate();
  const { nfcCurrentTab: activeTab, setNfcCurrentTab: setActiveTab } = useGlobal();
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [nfcData, setNfcData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [counts, setCounts] = useState({ allocated: 0, unallocated: 0, newly_added: 0 });
  const [sortByField, setSortByField] = useState("nfc_masters.created_at");
  const [sortBy, setSortBy] = useState("desc");
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    const typeMap = {
      "Allocated": "allocated",
      "Not allocated": "unallocated",
      "Newly Added Tags": "newly_added"
    };

    const params = {
      limit: itemsPerPage,
      skip: currentPage * itemsPerPage,
      search: searchQuery,
      type: typeMap[activeTab],
      sortByField,
      sortBy
    };

    const response = await getNfcList(params);
    if (response?.data?.success) {
      const records = response.data.data || [];
      const total = response.data.total_recs || 0;
      setNfcData(records);
      setTotalCount(total);
      setPageCount(Math.ceil(total / itemsPerPage));
      setCounts({
        allocated: response.data.allocated || 0,
        unallocated: response.data.unallocated || 0,
        newly_added: response.data.newly_added || 0
      });
    }
    setLoading(false);

  }, [itemsPerPage, currentPage, searchQuery, activeTab, sortByField, sortBy]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    setCurrentPage(0);
  }, [itemsPerPage]);

  const tabs = [

    { label: "Allocated", count: counts.allocated },
    { label: "Not allocated", count: counts.unallocated },
    { label: "Newly Added Tags", count: counts.newly_added },
  ];

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(0);
  };

  const decodeSeqNo = (encoded) => {
    if (!encoded) return "-";
    try {
      return atob(encoded);
    } catch (e) {
      return encoded;
    }
  };

  return (
    <div style={{ fontFamily: "Epilogue", backgroundColor: "#FFFFFF", minHeight: "100vh" }}>
      <TopBar />
      <div style={{ display: "flex" }}>
        <Sidebar activeMenu={"NFC"} />
        <div
          style={{
            flex: 1,
            padding: "24px",
            backgroundColor: "#FFFFFF",
            minHeight: "calc(100vh - 64px)",
          }}
        >
          {/* Dashed Separator & Subtitle */}
          <Row className="mb-4 align-items-center">
            <Col>
              <div style={{ borderTop: "1px dashed #E5E5E5", width: "100%" }}></div>
            </Col>
            <Col xs="auto">
              <div
                style={{
                  fontWeight: 400,
                  fontSize: 13,
                  color: "#8790A1",
                  whiteSpace: "nowrap",
                }}
              >
                Set up your organization with these master settings and manage them seamlessly from here.
              </div>
            </Col>
            <Col>
              <div style={{ borderTop: "1px dashed #E5E5E5", width: "100%" }}></div>
            </Col>
          </Row>

          {/* Header Section */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "16px",
            }}
          >
            <div style={{ fontWeight: "700", fontSize: "20px", color: "#172B4D" }}>
              NFC ({totalCount})
            </div>

            <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
              {/* Search Bar */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#FFFFFF",
                  border: "1px solid #E5E5E5",
                  borderRadius: "14px",
                  padding: "8px",
                  width: "340px",
                  height: "36px",
                  boxSizing: "border-box"
                }}
              >
                <img src={searchIcon} alt="search" style={{ marginRight: "-5px", width: "22px" }} />
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={handleSearch}
                  style={{
                    border: "none",
                    outline: "none",
                    boxShadow: "none",
                    width: "100%",
                    fontSize: "14px",
                    color: "#8790A1",
                    backgroundColor: "transparent"
                  }}
                />
              </div>

              {/* Sort Dropdown */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#FFFFFF",
                  border: "1px solid #E5E5E5",
                  borderRadius: "12px",
                  padding: "0 16px",
                  height: "36px",
                  cursor: "pointer",
                  boxSizing: "border-box"
                }}
              >
                <img src={sortIcon} alt="sort" style={{ marginRight: "8px", width: "16px" }} />
                <select
                    style={{
                        outline: "none",
                        border: "none",
                        fontFamily: "Epilogue",
                        fontSize: "14px",
                        fontWeight: "600",
                        color: "#172B4D",
                        backgroundColor: "transparent",
                        cursor: "pointer"
                    }}
                    onChange={(e) => {
                        const [field, order] = e.target.value.split(" ");
                        setSortByField(field);
                        setSortBy(order);
                    }}
                    value={`${sortByField} ${sortBy}`}
                >
                    <option value="nfc_masters.created_at desc">Default (date created)</option>
                    <option value="nfc_masters.nfc_tag asc">NFC Tag (Asc)</option>
                    <option value="nfc_masters.nfc_tag desc">NFC Tag (Desc)</option>
                    <option value="nfc_masters.status asc">Status (Asc)</option>
                    <option value="nfc_masters.status desc">Status (Desc)</option>
                </select>
              </div>

              {/* Filter Button */}
              <button
                style={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#FFFFFF",
                  border: "1px solid #E5E5E5",
                  borderRadius: "12px",
                  padding: "10px 16px",
                  height: "36px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#172B4D",
                  boxSizing: "border-box"
                }}
              >
                <img src={filterIcon} alt="filter" style={{ marginRight: "8px", width: "14px" }} />
                Filter
              </button>

              {/* Add Button */}
              <button
                style={{
                  backgroundColor: "#2C8C53",
                  color: "#FFFFFF",
                  border: "none",
                  borderRadius: "12px",
                  padding: "8px 20px",
                  height: "36px",
                  fontSize: "14px",
                  fontWeight: "700",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  boxSizing: "border-box"
                }}
              >
                <img src={addIcon} alt="add" style={{ width: "16px" }} />
                Add
              </button>
            </div>
          </div>

          {/* Tabs Section */}
          <div style={{ display: "flex", gap: "8px", marginBottom: "16px" }}>
            {tabs.map((tab) => (
              <div
                key={tab.label}
                onClick={() => {
                    setActiveTab(tab.label);
                    setCurrentPage(0);
                }}
                style={{
                  padding: "10px 16px",
                  borderRadius: "12px",
                  fontSize: "13px",
                  fontWeight: "600",
                  cursor: "pointer",
                  height: "36px",
                  backgroundColor: activeTab === tab.label ? "#D6FFE6" : "#F8F8F8",
                  color: activeTab === tab.label ? "#2C8C53" : "#172B4D",
                  transition: "all 0.2s ease",
                }}
              >
                {tab.label} ({tab.count})
              </div>
            ))}
          </div>

          {/* Table Container */}
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ backgroundColor: "#F9FAFB", textAlign: "left" }}>
                  <th style={headerStyle}>S.No</th>
                  <th style={headerStyle}>Seq. No</th>
                  <th style={headerStyle}>Assigned For</th>
                  <th style={headerStyle}>Person Info</th>
                  <th style={headerStyle}>Vehicle No.</th>
                  <th style={headerStyle}>Gate</th>
                  <th style={headerStyle}>Status</th>
                  <th style={headerStyle}>Last Modified</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                    <tr>
                        <td colSpan="8" style={{ textAlign: "center", padding: "40px", color: "#8790A1" }}>Loading...</td>
                    </tr>
                ) : nfcData.length === 0 ? (
                    <tr>
                        <td colSpan="8" style={{ textAlign: "center", padding: "40px", color: "#8790A1" }}>No data found</td>
                    </tr>
                ) : nfcData.map((item, index) => (
                  <tr
                    key={index}
                    onClick={() => navigate("/nfc/view", { state: { id: item.id } })}
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(null)}
                    style={{
                      borderBottom: "1px solid #F0F2F5",
                      backgroundColor: hoveredIndex === index ? "#FAFBFC" : "transparent",
                      cursor: "pointer",
                      position: "relative",
                    }}
                  >
                    <td style={cellStyle}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div
                          style={{
                            width: "3px",
                            height: "100%",
                            backgroundColor: hoveredIndex === index ? "#2C8C53" : "transparent",
                            position: "absolute",
                            left: 0,
                            top: 0,
                            bottom: 0,
                          }}
                        />
                        <span style={{ marginLeft: "12px" }}>{currentPage * itemsPerPage + index + 1}</span>
                      </div>
                    </td>
                    <td style={{ ...cellStyle, fontWeight: "500", color: "#172B4D" }}>{decodeSeqNo(item.seq_no)}</td>
                    <td style={cellStyle}>{item.assign_type ?? "-"}</td>
                    <td style={cellStyle}>
                      {item.person_name ? (
                        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                          <img 
                            src={(item.assign_type === 'Visitor' ? item.visitor_profile : item.driver_profile) || defaultProfile} 
                            alt="avatar" 
                            style={{ width: "40px", height: "40px", borderRadius: "50%", objectFit: "cover" }}
                            onError={(e) => { e.target.src = defaultProfile; }}
                          />
                          <div style={{ display: "flex", flexDirection: "column" }}>
                            <span style={{ fontWeight: "500", color: "#172B4D", fontSize: "14px" }}>{item.person_name}</span>
                            <span style={{ color: "#8790A1", fontSize: "12px" }}>{item.mobile_number}</span>
                          </div>
                        </div>
                      ) : "-"}
                    </td>
                    <td style={cellStyle}>{item.vehicle_number ?? "-"}</td>
                    <td style={cellStyle}>{item.gate_name ?? "-"}</td>
                    <td style={cellStyle}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          borderRadius: "12px",
                          padding: "7px 10px",
                          width: "fit-content",
                          backgroundColor: "#F7F7F7",
                        }}
                      >
                        <div
                          style={{
                            width: "8px",
                            height: "8px",
                            borderRadius: "50%",
                            backgroundColor: item.status ? "#2C8C53" : "#FF0000",
                          }}
                        />
                        <span style={{ fontSize: "13px", fontWeight: "400", color: "#172B4D" }}>{item.status ? "Active" : "Inactive"}</span>
                      </div>
                    </td>
                    <td style={cellStyle}>{item.update_at ?? "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {nfcData.length > 0 && !loading && (
            <CustomPagination
              itemsPerPage={itemsPerPage}
              setItemsPerPage={setItemsPerPage}
              pageCount={pageCount}
              onPageChange={handlePageClick}
              currentPage={currentPage}
            />
          )}

        </div>
      </div>
    </div>
  );
};

const headerStyle = {
  padding: "10px 16px",
  fontSize: "13px",
  fontWeight: "600",
  color: "#172B4D",
  border: "1px solid #E5E5E5",
};

const cellStyle = {
  padding: "10px 16px",
  fontSize: "13px",
  fontWeight: "400",
  color: "#172B4D",
  verticalAlign: "middle",
  border: "1px solid #E5E5E5",
};

export default NfcList;
